import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../../capabilities';
import { waitForElement } from '../../../common/utils';
import { NOTIFICATIONS_BANNER_COMPONENT } from '../../constants';
import { Channels } from '../constants';
import { getBannerStyle, getPath, getQueryParams } from '../internal';
import { args } from '../../../common/args';
const NAVIGATION_BANNER_IFRAME_ID = 'in-app-notifications-banner-iframe';
export const bannerNotificationsComponentDef = defineComponent(NOTIFICATIONS_BANNER_COMPONENT, () => ({
  name: NOTIFICATIONS_BANNER_COMPONENT,
  path: getPath({
    channel: Channels.BANNERS,
    allowHubless: true
  }),
  enableHubless: true,
  queryParams: getQueryParams(),
  propsSchema: {
    iaDetails: args.optional(args.object({
      iaName: args.string(),
      isOptedInToIA: args.or(args.bool(), args.nullType())
    }))
  },
  initialProps: {
    iaDetails: undefined
  },
  iframeProps: {
    id: NAVIGATION_BANNER_IFRAME_ID,
    style: getBannerStyle()
  },
  renderTo: () => waitForElement('#notificationBannerContainer'),
  initiallyOpen: true,
  deferLoading: false,
  capabilities: [capabilities.RESTYLE_CAP.getName()]
}));